import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Outlet, useLocation } from "react-router-dom";
import UserNavBar from "../UserDashboard/UserNavBar";

export default function UserDashboardLayout() {
  const location = useLocation();
  const isChatRoute =
    location.pathname.includes("/group-chats/") ||
    location.pathname.includes("/chats/");

  return (
    <AnimatePresence>
      <div className="max-w-[450px] w-screen m-auto bg-gray-100">
        <motion.div className="relative max-w-[450px] m-auto w-screen">
          <div className={isChatRoute ? "pb-0" : "pb-28"}>
            <Outlet />
          </div>
        </motion.div>

        <div className="fixed left-0 bottom-0 mx-auto w-full">
          <UserNavBar />
        </div>
      </div>
    </AnimatePresence>
  );
}